// extracted by mini-css-extract-plugin
export var container = "_i2-0";
export var outlet = "_i2-1";
export var outletEnter = "_i2-2";
export var outletEnterActive = "_i2-3";
export var outletExit = "_i2-4";
export var outletExitActive = "_i2-5";